import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, TThunkApi } from 'store/store';
import { getAllConfigs, updateConfig } from 'api/MakhsanApi';

export interface SystemConfigView {
  id?: number;
  module?: string;
  name?: string;
  value?: string;
  type?: string;
  regex?: string;
}

export interface ISystemConfigViews {
  [key: number]: SystemConfigView;
}

const initialState: ISystemConfigViews = {};

const addOrUpdateSystemConfigHandler = (
  state: ISystemConfigViews,
  action: PayloadAction<{ systemConfigs: Array<SystemConfigView> }>
) => {
  action.payload.systemConfigs.forEach((systemConfig) => {
    state[systemConfig.id!] = systemConfig;
  });
};

export const makhsanGetSystemConfigsFn = async (
  _: any,
  ThunkApi: TThunkApi
) => {
  const store = ThunkApi.getState() as RootState;

  return getAllConfigs(store).then(({ data: systemConfigs }) => {
    ThunkApi.dispatch(addOrUpdateSystemConfig({ systemConfigs }));
    return Promise.resolve();
  });
};
const makhsanGetSystemConfigs = createAsyncThunk(
  'makhsanSystemConfig/makhsanGetSystemConfigs',
  makhsanGetSystemConfigsFn
);

export const makhsanUpdateConfigFn = async (
  { config }: { config: SystemConfigView },
  ThunkApi: TThunkApi
) => {
  const store = ThunkApi.getState() as RootState;
  return updateConfig(store, config).then(({ data: systemConfigs }) => {
    ThunkApi.dispatch(
      addOrUpdateSystemConfig({ systemConfigs: [systemConfigs] })
    );
    return Promise.resolve({ systemConfigs: [systemConfigs] });
  });
};
const makhsanUpdateConfig = createAsyncThunk(
  'makhsanSystemConfig/makhsanUpdateConfig',
  makhsanUpdateConfigFn
);

const makhsanSystemConfigSlice = createSlice({
  name: 'makhsanSystemConfig',
  initialState: initialState,
  reducers: {
    addOrUpdateSystemConfig: addOrUpdateSystemConfigHandler,
  },
});

export const { addOrUpdateSystemConfig } = makhsanSystemConfigSlice.actions;

export { makhsanGetSystemConfigs, makhsanUpdateConfig };

export default makhsanSystemConfigSlice.reducer;
